import { MTypography } from 'src/lib';

export const LiquidityNeedsTooltipContent = () => (
  <div>
    <MTypography variant='body1'>
      Liquidity is the ability to quickly and easily convert to cash all, or a portion, of the investments in this
      account without experiencing significant loss in value from, for example, the lack of a ready market, or incurring
      significant costs or penalties.
    </MTypography>
    <MTypography variant='body1'>Very Important</MTypography>
    <MTypography variant='body1'>
      The ability to quickly and easily convert to cash all or a portion of the investments in under 5 years in this
      account is very important.
    </MTypography>
    <MTypography variant='body1'>Somewhat Important</MTypography>
    <MTypography variant='body1'>
      The ability to quickly and easily convert to cash all or a portion of the investments in this account in over 5
      years is somewhat important.
    </MTypography>
    <MTypography variant='body1'>Not Important</MTypography>
    <MTypography variant='body1'>
      The ability to quickly and easily convert to cash all or a portion of the investments in this account is not
      important.
    </MTypography>
  </div>
);
